<template>
  <TemplateHomeDetail :page="page" />
</template>

<script setup lang="ts">
import { getIndirectClientHeaders, seoHead } from '~/assets/seo'
import { getSiteConfig } from '~/composables/craft'
import { setCacheControlHeader, setPageCacheControlHeader } from '~/composables/util'
import { useNavigationStore } from '~/store/navigation'
import { useGlobalStore } from '~/store/global'
import { usePageStore } from '~/store/page'

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    nl: '/www',
  },
})

const route = useRoute()
const navigationStore = useNavigationStore()
const globalStore = useGlobalStore()
const pageStore = usePageStore()

const { site } = getSiteConfig(route)

const [_, seoGlobal] = await Promise.all([navigationStore.fetch(site), globalStore.fetchSeo()])
// Use `useAsyncData()` to prevent hydration mismatches in homepage data
const { data: page } = await useAsyncData(`home-page-${site}`, () => pageStore.fetchHome({ site, push: true, options: { headers: getIndirectClientHeaders() } }))

if (!page.value) {
  setCacheControlHeader(600, true)
  throw createError({ statusCode: 404, message: 'HomePage not available' })
}

setPageCacheControlHeader(page.value)

useHead(() => seoHead(page.value, seoGlobal))
</script>
